import { createUseStyles } from 'react-jss';

import { ITheme } from '../../../styles/theme';
import { mediaQuery } from '../../../styles/helpers';
import { FontWeight } from '../../../styles/fonts';

const useStyles = createUseStyles(
  ({ breakpoints }: ITheme) => ({
    container: {
      margin: 'auto',
      [mediaQuery(breakpoints.tablet)]: {
        padding: '0px 24px',
      },
    },
    alert: {
      width: '100%',
      display: 'flex',
      background: '#F67E0C',
      borderRadius: '12px',
      zIndex: 11,
      alignItems: 'center',
      gap: '8px',
      padding: [12, 16],
      [mediaQuery(breakpoints.tablet)]: {
        alignItems: 'self-start',
      },
    },
    textContent: {
      flex: 1,
    },
    description: {
      fontWeight: FontWeight.SemiBold,
      fontSize: '16px',
      lineHeight: '24px',
      color: '#080808',
    },
    label: {
      cursor: 'pointer',
      color: '#FFFFFF',
      fontWeight: FontWeight.SemiBold,
      fontSize: '16px',
      lineHeight: '24px',
      textDecoration: 'underline',
    },
    input: {
      display: 'none',
    },
    btnClose: {
      cursor: 'pointer',
      '& svg path': {
        fill: '#080808',
      },
    },
  }),
  {
    name: 'alert',
  },
);

export default useStyles;
